import { EMAIL_INVITATION } from '../entities/IRoleManager';
import { isValidEmail } from './emailChecker';

export const SHADOW_USER_ID = 'SHADOW_USER';

export type InviteReceiverEmailSource = {
    email?: string | null;
    emailContact?: string | null;
    upn?: string | null;
    secondLine?: string | null;
};

const firstValidEmail = (...candidates: Array<string | null | undefined>): string | undefined => {
    for (const candidate of candidates) {
        const trimmed = candidate?.trim();
        if (trimmed && isValidEmail(trimmed)) {
            return trimmed;
        }
    }
    return undefined;
};

export const pickInviteReceiverEmail = (source?: InviteReceiverEmailSource | null): string | undefined =>
    firstValidEmail(source?.email, source?.emailContact, source?.upn, source?.secondLine);

export const isExistingInvitePrincipalId = (id?: string | null): boolean => {
    const trimmed = id?.trim();
    return Boolean(trimmed) && trimmed !== EMAIL_INVITATION && trimmed !== SHADOW_USER_ID;
};

export const inviteResourceOptions = (
    principalId: string | undefined,
    message?: string
): { message?: string; receiverId?: string } => ({
    message,
    receiverId: isExistingInvitePrincipalId(principalId) ? principalId : undefined
});
